import { createApi } from '@/api/modules/utils'

const baseUrl = '/article_generation/personal'
const api = createApi(baseUrl)

// 用户相关API
export const articleGenerationPersonalApi = {
    articleTitle: api('article_title', 'post'), //ai生成文章标题
    articleDescribe: api('article_describe', 'post'), //ai生成文章内容
    refSearch: api('ref_search', 'post'), //参考文章搜索(百度)
    refAnalyze: api('ref_analyze', 'post'), //参考文章提取业务核心词
    titleV2: api('title_v2', 'post'), //生成候选标题
    outlineV2: api('outline_v2', 'post'), //生成文章大纲
    articleV2: api('article_v2', 'post'), //生成深度文章
    deepTask: api('deep_task', 'post'), //提交深度文章任务
    deepTaskFind: api('deep_task/find', 'get'), //查询深度文章任务
}